import * as z from "zod/v4";

export const getActualStoreUrl = {
  name: "getActualStoreUrl" as const,
  input: z.object({ storeUrl: z.string() }),
  output: z.object({ actualUrl: z.string() }),
};
